import { render, staticRenderFns } from "./Review.vue?vue&type=template&id=0b308688&scoped=true&"
import script from "./Review.vue?vue&type=script&lang=ts&setup=true&"
export * from "./Review.vue?vue&type=script&lang=ts&setup=true&"
import style0 from "./Review.vue?vue&type=style&index=0&id=0b308688&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b308688",
  null
  
)

export default component.exports